<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.employeeEntitlement_calc }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="cantCalc ? data.sysText.close : data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  @if (cantCalc) {
    <p class="body2">{{ data.sysText.employeeEntitlement_missingDetailsMessage }}:</p>
    @for(missingDetail of this.missingDetails; track missingDetail) {
      <p class="body2">
        <span class="bullet-space">&bull;</span>{{ missingDetail }}
      </p>
    }
  } @else if (confirmResult != null) {
    <p class="body2">{{ data.sysText.employeeEntitlement_calcEntitlementConfMessage1 }}:</p>
    <div class="section">
      @for(entitlement of confirmResult.entitlements; track entitlement) {
        <p class="body2"><span class="semibold">{{ entitlement.bankName + ": "}}</span>{{ entitlement.hours + " " + data.sysText.employeeEntitlement_totalHours }}</p>
      }
    </div>
    @if (data.caseStartDate) {
      <p class="section body2">{{ data.sysText.employeeEntitlement_calcEntitlementDateMessage.replace("@[startDate]", data.caseStartDate | date) }}</p>
    }
    <p class="section body2">{{ data.sysText.employeeEntitlement_calcEntitlementConfMessage2 }}</p>
  } @else {
    <p class="body2">{{ data.sysText.employeeEntitlement_calcEntitlementMessage }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      [mat-dialog-close]="false"
      color="accent"
      [disabled]="isSubmitting">
      {{ cantCalc ? data.sysText.close : data.sysText.cancel }}
    </button>
  }
  @if (!cantCalc) {
    <!-- one button for both steps (calculate, then add), so focus stays on it when the step changes. it keeps focus while busy:
    showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit(confirmResult !== null)">
      {{ confirmResult === null ? data.sysText.calculate : data.sysText.add }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  }
</mat-dialog-actions>
